import _extends from 'babel-runtime/helpers/extends';

import { mapGetters } from 'vuex';
import SidebarItem from './sidebar-item';
import ScrollBar from '@/components/ScrollBar';

export default {
  components: { SidebarItem: SidebarItem, ScrollBar: ScrollBar },
  computed: _extends({}, mapGetters(['permission_routers', 'sidebar']), {
    isCollapse: function isCollapse() {
      return !this.sidebar.opened;
    }
  })
};